import { text } from "../bytes.ts";
import { toBytesAsync } from "../hash/util.ts";
import hash, { adler32, crc32, hmac, sha1, sha256, sha512, } from "../hash/web.ts";
export default hash;
export { adler32, crc32, hmac, sha1, sha256, sha512 };
export async function md5(data, encoding = undefined) {
    let bytes = await toBytesAsync(data);
    const hash = await crypto.subtle.digest("MD5", bytes);
    if (encoding === "hex") {
        return text(new Uint8Array(hash), "hex");
    }
    else if (encoding === "base64") {
        return text(new Uint8Array(hash), "base64");
    }
    else {
        return hash;
    }
}
//# sourceMappingURL=hash.js.map